module.exports = __webpack_public_path__ + "static/media/SearchEmployeeCard.1249db71.svg";